import * as React from 'react';
import LimitReachedComponent, { LimitReachedComponentProps } from './LimitReached.component';
import Modal from 'src/modules/commons/modal-handler/jQueryModal';

interface Props {
  modalRef?: Modal;
  amountInvestedLastYear: number;
  reachedType: number;
}

class LimitReachedContainer extends React.Component<Props> {

  public render(): React.ReactNode {
    return <LimitReachedComponent {...this.getComponentProps()}/>;
  }

  private getComponentProps(): LimitReachedComponentProps {
    return {
      amountInvestedLastYear: this.props.amountInvestedLastYear,
      modalRef: this.props.modalRef,
      reachedType: this.props.reachedType
    };
  }
}

export default LimitReachedContainer;



// WEBPACK FOOTER //
// ./src/modules/modals/investment-funnel/limit-reached/LimitReached.container.tsx